import React from 'react';
import PageTop from '../../../core/components/PageTop';

// components
import IraListTable from './table/IraListTable';

// hooks
import { useIraListInit } from './pagehooks/useIraListInit';

const PageAdminIraList = (): JSX.Element => {
    useIraListInit();
    return (
        <>
            <PageTop
                title="IRA Payor List"
                icon="sprite-payor"
            />
            <div className="payor-feature payor-list">
                <IraListTable />
            </div>
        </>
    );
};

export default PageAdminIraList;
